<template>
  <div class="home-container bgcolor">
    <div class="content-wrapper">
      <!-- Logo 区域 -->
      <div class="logo-section">
        <div class="logo-icon">
          <svg width="80" height="80" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="50" r="45" fill="#8e53c4" opacity="0.1"/>
            <path d="M50 20 L65 35 L80 35 L60 50 L70 70 L50 60 L30 70 L40 50 L20 35 L35 35 Z" fill="#8e53c4"/>
            <circle cx="50" cy="35" r="8" fill="#fff"/>
          </svg>
        </div>
        <h1 class="main-title">天赋自测</h1>
        <p class="subtitle">Talent Assessment</p>
        <div class="website-author-link">
          <a 
            href="https://xhslink.com/m/96XmZgiwyxN" 
            target="_blank" 
            rel="noopener noreferrer"
            class="author-link"
          >
            @西西的奇思妙想
          </a>
        </div>
      </div>

      <!-- 介绍文字 -->
      <div class="intro-section">
        <p class="intro-text">
          每个人都有自己独特的天赋
        </p>
        <p class="intro-text">
          通过科学的方式帮你发现自己的10种天赋能力，找到最适合的发展方向
        </p>
        <p class="intro-desc">
          本测试来自北京联合出版公司出版社的《做自己擅长的事，还是喜欢的？》，作者 [奥] Aljoscha Neubauer。
        </p>
      </div>

      <!-- 特点介绍 -->
      <div class="features-section">
        <div class="feature-item">
          <div class="feature-icon">📊</div>
          <div class="feature-title">全面评估</div>
          <div class="feature-desc">10个维度深度分析</div>
        </div>
        <div class="feature-item">
          <div class="feature-icon">⚡</div>
          <div class="feature-title">快速测试</div>
          <div class="feature-desc">仅需5-10分钟</div>
        </div>
        <div class="feature-item">
          <div class="feature-icon">🎯</div>
          <div class="feature-title">精准结果</div>
          <div class="feature-desc">可视化雷达图展示</div>
        </div>
      </div>

      <!-- 测试信息 -->
      <div class="test-info">
        <div class="info-item">
          <span class="info-label">测试题数：</span>
          <span class="info-value">40 题</span>
        </div>
        <div class="info-item">
          <span class="info-label">预计时长：</span>
          <span class="info-value">5-10 分钟</span>
        </div>
      </div>

      <!-- 开始按钮 -->
      <div class="action-section">
        <button class="start-btn" @click="startTest">
          <span class="btn-text">开始测试</span>
          <span class="btn-arrow">→</span>
        </button>
        <p class="tip-text">请在安静的环境下完成测试，根据第一感觉作答</p>
      </div>

      <!-- 底部说明 -->
      <div class="footer-section">
        <p class="footer-text">测试结果仅供参考</p>
        <p class="footer-text">本测试不会收集任何个人信息</p>
      </div>
    </div>

    <!-- 激活码弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">激活码验证</h3>
          <button class="modal-close" @click="closeModal">×</button>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <input 
              v-model="activationCode" 
              type="text" 
              class="activation-input"
              placeholder="输入激活码开始天赋自测"
              @keyup.enter="verifyCode"
              ref="activationInput"
            />
            <div v-if="errorMessage" class="error-message">
              {{ errorMessage }}
            </div>
          </div>
          
          <div class="modal-desc">
            <p class="desc-text">
              已购买用户请联系
              <a 
                href="https://xhslink.com/m/96XmZgiwyxN" 
                target="_blank" 
                rel="noopener noreferrer"
                class="purchase-link"
              >
                @西西的奇思妙想
              </a>
              ，发送关键字
              <span class="keyword-tag">"激活码"</span>
              领取
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-cancel" @click="closeModal">取消</button>
          <button class="btn btn-confirm" @click="verifyCode" :disabled="!activationCode.trim()">
            提交
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hasActivationCode, setActivationCode } from '@/utils/storage'

export default {
  name: 'HomePage',
  data() {
    return {
      showModal: false,
      activationCode: '',
      errorMessage: '',
      correctCode: 'cc1900'
    }
  },
  mounted() {
    // 接收 URL r 参数并保存到本地缓存（JSON）
    const r = this.$route?.query?.r
    if (r) {
      setActivationCode(r, 'query')
    }
  },
  methods: {
    // 开始测试：优先识别本地缓存是否存在激活码
    startTest() {
      if (hasActivationCode()) {
        this.$router.push('/test')
      } else {
        this.showActivationModal()
      }
    },
    
    // ====== 以下为激活码功能（已暂时禁用，需要时可恢复） ======
    // 恢复方法：将按钮的 @click="startTest" 改为 @click="showActivationModal"
    
    showActivationModal() {
      this.showModal = true
      this.activationCode = ''
      this.errorMessage = ''
      this.$nextTick(() => {
        this.$refs.activationInput?.focus()
      })
    },
    
    closeModal() {
      this.showModal = false
      this.activationCode = ''
      this.errorMessage = ''
    },
    
    verifyCode() {
      if (!this.activationCode.trim()) {
        this.errorMessage = '请输入激活码'
        return
      }
      
      // 忽略大小写进行验证
      if (this.activationCode.trim().toLowerCase() === this.correctCode.toLowerCase()) {
        // 校验通过后保存到本地缓存（JSON），下次可直接跳过输入
        setActivationCode(this.activationCode, 'manual')
        this.closeModal()
        this.$router.push('/test')
      } else {
        this.errorMessage = '激活码错误，请重新输入'
        this.activationCode = ''
        this.$nextTick(() => {
          this.$refs.activationInput?.focus()
        })
      }
    }
  }
}
</script>

<style scoped>
.home-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.content-wrapper {
  max-width: 600px;
  width: 100%;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 24px;
  padding: 48px 32px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Logo 区域 */
.logo-section {
  text-align: center;
  margin-bottom: 20px;
}

.logo-icon {
  margin-bottom: 20px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

.main-title {
  font-size: 42px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 8px;
  letter-spacing: 2px;
}

.subtitle {
  font-size: 16px;
  color: #8e53c4;
  font-weight: 500;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.website-author-link {
  text-align: center;
  margin-top: 4px;
}

.author-link {
  color: #585656;
  font-size: 11px;
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 400;
  letter-spacing: 0.3px;
}

.author-link:hover {
  color: #8e53c4;
  text-decoration: underline;
}

/* 介绍区域 */
.intro-section {
  text-align: center;
  margin-bottom: 40px;
  padding: 0 20px;
}

.intro-text {
  font-size: 18px;
  color: #34495e;
  margin-bottom: 12px;
  line-height: 1.6;
}

.intro-desc {
  font-size: 14px;
  color: #7f8c8d;
  margin-top: 20px;
  line-height: 1.8;
}

/* 特点展示 */
.features-section {
  display: flex;
  justify-content: space-around;
  margin-bottom: 40px;
  gap: 20px;
}

.feature-item {
  flex: 1;
  text-align: center;
  padding: 20px 10px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(142, 83, 196, 0.15);
}

.feature-icon {
  font-size: 32px;
  margin-bottom: 12px;
}

.feature-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
}

.feature-desc {
  font-size: 13px;
  color: #7f8c8d;
}

/* 测试信息 */
.test-info {
  background: linear-gradient(135deg, #8e53c4 0%, #a66fd4 100%);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
  display: flex;
  justify-content: space-around;
}

.info-item {
  text-align: center;
}

.info-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  display: block;
  margin-bottom: 8px;
}

.info-value {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

/* 开始按钮区域 */
.action-section {
  text-align: center;
  margin-bottom: 32px;
}

.start-btn {
  width: 100%;
  padding: 18px 32px;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #8e53c4 0%, #a66fd4 100%);
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(142, 83, 196, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.start-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(142, 83, 196, 0.4);
  background: linear-gradient(135deg, #a66fd4 0%, #8e53c4 100%);
}

.start-btn:active {
  transform: translateY(0);
}

.btn-text {
  font-size: 20px;
}

.btn-arrow {
  font-size: 24px;
  transition: transform 0.3s ease;
}

.start-btn:hover .btn-arrow {
  transform: translateX(5px);
}

.tip-text {
  margin-top: 16px;
  font-size: 13px;
  color: #7f8c8d;
}

/* 底部说明 */
.footer-section {
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid #e9ecef;
}

.footer-text {
  font-size: 12px;
  color: #95a5a6;
  margin-bottom: 8px;
}

/* 响应式设计 */
@media (max-width: 640px) {
  .content-wrapper {
    padding: 32px 24px;
  }

  .main-title {
    font-size: 36px;
  }

  .subtitle {
    font-size: 14px;
  }

  .features-section {
    flex-direction: column;
    gap: 12px;
  }

  .feature-item {
    padding: 16px;
  }

  .test-info {
    flex-direction: column;
    gap: 16px;
  }

  .start-btn {
    padding: 16px 24px;
    font-size: 18px;
  }

  .btn-text {
    font-size: 18px;
  }
}

/* 激活码弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 0 24px;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 20px;
}

.modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.modal-close:hover {
  background: #f8f9fa;
  color: #495057;
}

.modal-body {
  padding: 0 24px 20px 24px;
}

.modal-desc {
  margin-bottom: 20px;
  text-align: center;
}

.desc-text {
  color: #6c757d;
  font-size: 14px;
  line-height: 1.8;
  margin: 0;
  display: inline-block;
}

.purchase-link {
  color: #8e53c4;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  margin: 0 4px;
  display: inline-block;
}

.purchase-link:hover {
  color: #a66fd4;
  text-decoration: underline;
}

.keyword-tag {
  display: inline-block;
  background: rgba(142, 83, 196, 0.1);
  color: #8e53c4;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 13px;
  margin: 0 4px;
  border: 1px dashed rgba(142, 83, 196, 0.3);
}

.input-group {
  margin-bottom: 20px;
}

.activation-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.activation-input:focus {
  outline: none;
  border-color: #8e53c4;
  box-shadow: 0 0 0 3px rgba(142, 83, 196, 0.1);
}

.error-message {
  color: #dc3545;
  font-size: 14px;
  margin-top: 8px;
  text-align: center;
}

.modal-footer {
  display: flex;
  gap: 12px;
  padding: 0 24px 24px 24px;
}

.btn {
  flex: 1;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cancel {
  background: #f8f9fa !important;
  color: #6c757d !important;
  border: 1px solid #dee2e6 !important;
}

.btn-cancel:hover {
  background: #e9ecef !important;
  color: #5a6268 !important;
  transform: translateY(-2px);
}

.btn-confirm {
  background: linear-gradient(135deg, #8e53c4 0%, #a66fd4 100%) !important;
  color: #ffffff !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(142, 83, 196, 0.3) !important;
}

.btn-confirm:hover:not(:disabled) {
  background: linear-gradient(135deg, #a66fd4 0%, #8e53c4 100%) !important;
  box-shadow: 0 6px 20px rgba(142, 83, 196, 0.4) !important;
  transform: translateY(-2px);
}

.btn-confirm:disabled {
  background: #e9ecef !important;
  color: #adb5bd !important;
  border: 1px solid #dee2e6 !important;
  box-shadow: none !important;
  cursor: not-allowed;
  transform: none;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .modal-content {
    width: 95%;
    margin: 20px;
  }
  
  .modal-header,
  .modal-body,
  .modal-footer {
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>

